import { TableField } from "../../table-field";

export const fieldsArquivosPCA: TableField[] = [
  {
    key: "code",
    label: "Código",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "description",
    label: "Descrição",
    tdClass: "align-middle coldescwidth",
    thClass: "text-center coldescwidth",
    sortable: false,
  },
  {
    key: "status",
    label: "Status",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "pathSugerido",
    label: "Sugerido?",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: false,
  },
]; 
